import baseMessage from './baseMessage'
import { merge, cloneDeep } from 'lodash'
const cloneObj = cloneDeep(baseMessage)
const message = merge(
  cloneObj,
  {
    label: {
      dni: 'CUIL',
      userHint: 'Se puede buscar por Nombres, Apellidos, Documento de identidad'
    },
    menuComponent: {
      licences:{
        name: 'Vacaciones y Licencias',
        shortName: 'Licencias'
      },
    },
    homeComponent: {
      sections:{
      vacations_licenses: 'Vacaciones y Licencias',
      }
    },
    selfService: {
      fields: {
        cuentaBancaria: 'CBU',
        cbu: 'CBU',
      },
      fieldsError: {
        cbu: {
          regex: 'Solo se admiten números y letras',
          min: 'No cumple con el mínimo de caracteres',
          max: 'Se superó el máximo de caracteres',
          is_cbu: 'El CBU no tiene un formato válido',
          cbu_length: 'El CBU debe poseer 22 caracteres'
        }
      },
    },
  }
)
export const ES_AR = {
  message
}